// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/standard_2.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/standard_3.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/standard_1.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/standard.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HomePage.css */

/* Force HomePage to retain light mode styles regardless of global dark mode */
.home-container {
  background-color: #f8f9fa !important;
  color: #333 !important;
  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;
  font-weight: 300;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-x: hidden;
}

.home-container a {
  /* color: #0066cc !important; */
  color: white !important;
}

/* Optionally override other elements if needed */
.hero-section, .section-heading, .blurb-item, .cta-button, .stat-item {
  background-color: inherit !important;
  /* color: inherit !important; */
  color: white !important;
}

/* End of HomePage light mode overrides */

/* General HomePage styles */
.home-container {
  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;
  font-weight: 300;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #000, #1a1a1a);
  color: white;
  position: relative;
  overflow-x: hidden;
}

.home-content {
  padding: 20px;
  text-align: center;
  flex: 1 1;
  margin-bottom: 60px; /* Space for footer */
}

.hero-section {
  margin: 20px 0 40px;
  padding: 80px 40px;
  background: linear-gradient(135deg, #000, #1a1a1a);
  color: white;
  border-radius: 12px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
  overflow: hidden;
  transition: all 0.5s ease;
}

.hero-section:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
}

.hero-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0,0,0,0.8), rgba(0,0,0,0.8));
  z-index: 1;
}

.hero-section > * {
  position: relative;
  z-index: 2;
  animation: fadeInUp 1s ease-out;
}

.hero-section h1 {
  font-size: 4em;
  margin-bottom: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.hero-section p {
  font-size: 1.5em;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.hero-image {
  margin-top: 20px;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

.blurb-section {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  margin: 60px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.blurb-item {
  background-color: #222;
  padding: 0;
  width: 320px;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.7);
  overflow: hidden;
  transition: all 0.4s ease;
  height: 450px; /* Fixed height for all cards */
  display: flex;
  flex-direction: column;
  position: relative;
}

.blurb-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.9);
}

.blurb-item img {
  width: 100%;
  border-radius: 8px 8px 0 0;
}

.blurb-item h2 {
  margin: 0;
  padding: 20px 20px 10px;
  font-size: 1.8em;
  font-weight: 700;
}

.blurb-item p {
  font-size: 1.1em;
  line-height: 1.6;
  padding: 0 20px;
  margin: 0;
  flex: 1 1;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Animated underline for section headings */
.section-heading {
  position: relative;
  display: inline-block;
  margin-bottom: 40px;
  font-size: 2.5em;
  font-weight: 700;
}

.section-heading::after {
  content: '';
  position: absolute;
  width: 60%;
  height: 4px;
  bottom: -10px;
  left: 20%;
  background: linear-gradient(90deg, #555, #999);
  border-radius: 2px;
  transition: width 0.3s ease;
}

.section-heading:hover::after {
  width: 80%;
  left: 10%;
}

@media (max-width: 768px) {
  .hero-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: auto;
    padding: 60px 20px;
    background-attachment: scroll;
  }
  .hero-section h1 {
    font-size: 2.5em;
  }
  .hero-section p {
    font-size: 1.2em;
  }
  .blurb-item {
    height: 400px; /* Slightly shorter on mobile */
    min-height: unset;
  }
  .blurb-item p {
    -webkit-line-clamp: 3; /* Show fewer lines on mobile */
  }
  .section-icon {
    margin: 20px 0; /* Reduced margin on mobile */
  }
  .cta-button {
    margin: 20px auto; /* Reduced margin on mobile */
  }
  /* .about-section, .past-papers-section, .resources-section {
    text-align: center;
    align-items: center;
  } */
}

/* CSS rule to make the background sections use a background image with dark overlay for better readability */
.about-section, .past-papers-section, .resources-section {
  position: relative;
  color: white;
  padding: 30px 20px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.4s ease;
}

.about-section:hover, .past-papers-section:hover, .resources-section:hover {
  transform: scale(1.03);
}

.about-section::before, .past-papers-section::before, .resources-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.9));
  border-radius: inherit;
  z-index: 0;
  transition: background 0.3s ease;
}

.about-section:hover::before, .past-papers-section:hover::before, .resources-section:hover::before {
  background: linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.8));
}

.about-section > *, .past-papers-section > *, .resources-section > * {
  position: relative;
  z-index: 1;
}

/* Specific background images for each section */
.about-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center/cover;
}

.past-papers-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center/cover;
}

.resources-section {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center/cover;
}

/* Add animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Add a floating action button for quick navigation */
.floating-action-button {
  position: fixed;
  bottom: 80px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #333, #555);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.6);
  cursor: pointer;
  z-index: 100;
  transition: all 0.3s ease;
}

.floating-action-button:hover {
  transform: translateY(-5px) rotate(45deg);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.8);
}

/* Add a scroll indicator */
.scroll-indicator {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  animation: bounce 2s infinite;
}

.scroll-indicator svg {
  width: 40px;
  height: 40px;
  fill: white;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) translateX(-50%);
  }
  40% {
    transform: translateY(-20px) translateX(-50%);
  }
  60% {
    transform: translateY(-10px) translateX(-50%);
  }
}

/* Section icons */
.section-icon {
  font-size: 2.5rem;
  margin: 30px 0;
  color: white;
}

/* CTA Buttons */
.cta-button {
  background: linear-gradient(90deg, #1e3c72, #2a5298);
  color: white;
  padding: 12px 20px;
  border-radius: 30px;
  font-weight: 600;
  margin: 25px auto;
  width: 80%;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.7);
  background: linear-gradient(90deg, #2a5298, #1e3c72);
}

/* Testimonials Section */
.testimonials-section {
  margin: 80px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.testimonials-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 40px;
}

.testimonial-card {
  background: #222;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.7);
  padding: 30px;
  width: 350px;
  transition: all 0.4s ease;
  opacity: 0;
  transform: translateY(30px);
}

.testimonial-card.animated {
  opacity: 1;
  transform: translateY(0);
}

.testimonial-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.9);
}

.testimonial-content {
  font-style: italic;
  line-height: 1.6;
  color: #ccc;
  margin-bottom: 20px;
  position: relative;
}

.testimonial-content::before {
  content: '"';
  font-size: 60px;
  color: #fff;
  opacity: 0.1;
  position: absolute;
  top: -20px;
  left: -15px;
}

.testimonial-author {
  display: flex;
  align-items: center;
}

.author-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #0066cc;
  margin-right: 15px;
}

.author-info h4 {
  margin: 0;
  /* color: #333; */
  color: white;
  font-weight: 600;
}

.author-info p {
  margin: 5px 0 0;
  color: #bcb4b4;
  font-size: 0.9em;
}

/* Stats Section */
.stats-section {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 60px auto;
  max-width: 1000px;
  padding: 40px 20px;
  background: linear-gradient(135deg, #000, #1a1a1a);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
  color: white;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
}

.stats-section.animated {
  opacity: 1;
  transform: translateY(0);
}

.stat-item {
  text-align: center;
  padding: 20px;
}

.stat-item h3 {
  font-size: 3em;
  margin: 0;
  font-weight: 800;
  background: linear-gradient(90deg, #ffffff, #cccccc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.stat-item p {
  margin-top: 10px;
  font-size: 1.2em;
  opacity: 0.9;
}

/* Animation for scroll elements */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.animate-on-scroll.animated {
  opacity: 1;
  transform: translateY(0);
}

/* Add delay to stagger animations */
.blurb-section .blurb-item:nth-child(1) {
  transition-delay: 0.1s;
}

.blurb-section .blurb-item:nth-child(2) {
  transition-delay: 0.3s;
}

.blurb-section .blurb-item:nth-child(3) {
  transition-delay: 0.5s;
}

.testimonials-container .testimonial-card:nth-child(1) {
  transition-delay: 0.2s;
}

.testimonials-container .testimonial-card:nth-child(2) {
  transition-delay: 0.4s;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .testimonial-card {
    width: 100%;
  }
  
  .stats-section {
    flex-direction: column;
    gap: 20px;
  }
}

/* Force all text on HomePage to use Poppins ExtraLight font weight, except the header */
.home-container *:not(.site-header *) {
  font-weight: 300 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/HomePage.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB,8EAA8E;AAC9E;EACE,oCAAoC;EACpC,sBAAsB;EACtB,qDAAqD;EACrD,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,yCAAyC;;AAEzC,4BAA4B;AAC5B;EACE,qDAAqD;EACrD,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAO;EACP,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;EAClD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yDAA+C;EAC/C,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qEAAqE;EACrE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,aAAa,EAAE,+BAA+B;EAC9C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,SAAO;EACP,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,SAAS;EACT,8CAA8C;EAC9C,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa,EAAE,+BAA+B;IAC9C,iBAAiB;EACnB;EACA;IACE,qBAAqB,EAAE,+BAA+B;EACxD;EACA;IACE,cAAc,EAAE,6BAA6B;EAC/C;EACA;IACE,iBAAiB,EAAE,6BAA6B;EAClD;EACA;;;KAGG;AACL;;AAEA,6GAA6G;AAC7G;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wEAAwE;EACxE,sBAAsB;EACtB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,0EAAgE;AAClE;;AAEA;EACE,0EAAgE;AAClE;;AAEA;EACE,0EAA8D;AAChE;;AAEA,mBAAmB;AACnB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kDAAkD;EAClD,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,wFAAwF;AACxF;EACE,2BAA2B;AAC7B","sourcesContent":["/* HomePage.css */\n\n/* Force HomePage to retain light mode styles regardless of global dark mode */\n.home-container {\n  background-color: #f8f9fa !important;\n  color: #333 !important;\n  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;\n  font-weight: 300;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.home-container a {\n  /* color: #0066cc !important; */\n  color: white !important;\n}\n\n/* Optionally override other elements if needed */\n.hero-section, .section-heading, .blurb-item, .cta-button, .stat-item {\n  background-color: inherit !important;\n  /* color: inherit !important; */\n  color: white !important;\n}\n\n/* End of HomePage light mode overrides */\n\n/* General HomePage styles */\n.home-container {\n  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;\n  font-weight: 300;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(180deg, #000, #1a1a1a);\n  color: white;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.home-content {\n  padding: 20px;\n  text-align: center;\n  flex: 1;\n  margin-bottom: 60px; /* Space for footer */\n}\n\n.hero-section {\n  margin: 20px 0 40px;\n  padding: 80px 40px;\n  background: linear-gradient(135deg, #000, #1a1a1a);\n  color: white;\n  border-radius: 12px;\n  position: relative;\n  background-image: url('/public/standard_2.gif');\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 50vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);\n  overflow: hidden;\n  transition: all 0.5s ease;\n}\n\n.hero-section:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);\n}\n\n.hero-section::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(0,0,0,0.8), rgba(0,0,0,0.8));\n  z-index: 1;\n}\n\n.hero-section > * {\n  position: relative;\n  z-index: 2;\n  animation: fadeInUp 1s ease-out;\n}\n\n.hero-section h1 {\n  font-size: 4em;\n  margin-bottom: 20px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.hero-section p {\n  font-size: 1.5em;\n  max-width: 700px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.hero-image {\n  margin-top: 20px;\n  max-width: 100%;\n  height: auto;\n  border-radius: 10px;\n}\n\n.blurb-section {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 30px;\n  margin: 60px auto;\n  max-width: 1200px;\n  padding: 0 20px;\n}\n\n.blurb-item {\n  background-color: #222;\n  padding: 0;\n  width: 320px;\n  border-radius: 12px;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.7);\n  overflow: hidden;\n  transition: all 0.4s ease;\n  height: 450px; /* Fixed height for all cards */\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.blurb-item:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 30px rgba(0,0,0,0.9);\n}\n\n.blurb-item img {\n  width: 100%;\n  border-radius: 8px 8px 0 0;\n}\n\n.blurb-item h2 {\n  margin: 0;\n  padding: 20px 20px 10px;\n  font-size: 1.8em;\n  font-weight: 700;\n}\n\n.blurb-item p {\n  font-size: 1.1em;\n  line-height: 1.6;\n  padding: 0 20px;\n  margin: 0;\n  flex: 1;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Animated underline for section headings */\n.section-heading {\n  position: relative;\n  display: inline-block;\n  margin-bottom: 40px;\n  font-size: 2.5em;\n  font-weight: 700;\n}\n\n.section-heading::after {\n  content: '';\n  position: absolute;\n  width: 60%;\n  height: 4px;\n  bottom: -10px;\n  left: 20%;\n  background: linear-gradient(90deg, #555, #999);\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n.section-heading:hover::after {\n  width: 80%;\n  left: 10%;\n}\n\n@media (max-width: 768px) {\n  .hero-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    height: auto;\n    padding: 60px 20px;\n    background-attachment: scroll;\n  }\n  .hero-section h1 {\n    font-size: 2.5em;\n  }\n  .hero-section p {\n    font-size: 1.2em;\n  }\n  .blurb-item {\n    height: 400px; /* Slightly shorter on mobile */\n    min-height: unset;\n  }\n  .blurb-item p {\n    -webkit-line-clamp: 3; /* Show fewer lines on mobile */\n  }\n  .section-icon {\n    margin: 20px 0; /* Reduced margin on mobile */\n  }\n  .cta-button {\n    margin: 20px auto; /* Reduced margin on mobile */\n  }\n  /* .about-section, .past-papers-section, .resources-section {\n    text-align: center;\n    align-items: center;\n  } */\n}\n\n/* CSS rule to make the background sections use a background image with dark overlay for better readability */\n.about-section, .past-papers-section, .resources-section {\n  position: relative;\n  color: white;\n  padding: 30px 20px;\n  border-radius: 12px;\n  box-shadow: 0 8px 20px rgba(0,0,0,0.15);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: all 0.4s ease;\n}\n\n.about-section:hover, .past-papers-section:hover, .resources-section:hover {\n  transform: scale(1.03);\n}\n\n.about-section::before, .past-papers-section::before, .resources-section::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.9));\n  border-radius: inherit;\n  z-index: 0;\n  transition: background 0.3s ease;\n}\n\n.about-section:hover::before, .past-papers-section:hover::before, .resources-section:hover::before {\n  background: linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.8));\n}\n\n.about-section > *, .past-papers-section > *, .resources-section > * {\n  position: relative;\n  z-index: 1;\n}\n\n/* Specific background images for each section */\n.about-section {\n  background: url('/public/standard_3.gif') no-repeat center/cover;\n}\n\n.past-papers-section {\n  background: url('/public/standard_1.gif') no-repeat center/cover;\n}\n\n.resources-section {\n  background: url('/public/standard.gif') no-repeat center/cover;\n}\n\n/* Add animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Add a floating action button for quick navigation */\n.floating-action-button {\n  position: fixed;\n  bottom: 80px;\n  right: 30px;\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, #333, #555);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.6);\n  cursor: pointer;\n  z-index: 100;\n  transition: all 0.3s ease;\n}\n\n.floating-action-button:hover {\n  transform: translateY(-5px) rotate(45deg);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.8);\n}\n\n/* Add a scroll indicator */\n.scroll-indicator {\n  position: absolute;\n  bottom: 30px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  animation: bounce 2s infinite;\n}\n\n.scroll-indicator svg {\n  width: 40px;\n  height: 40px;\n  fill: white;\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0) translateX(-50%);\n  }\n  40% {\n    transform: translateY(-20px) translateX(-50%);\n  }\n  60% {\n    transform: translateY(-10px) translateX(-50%);\n  }\n}\n\n/* Section icons */\n.section-icon {\n  font-size: 2.5rem;\n  margin: 30px 0;\n  color: white;\n}\n\n/* CTA Buttons */\n.cta-button {\n  background: linear-gradient(90deg, #1e3c72, #2a5298);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 30px;\n  font-weight: 600;\n  margin: 25px auto;\n  width: 80%;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n}\n\n.cta-button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.7);\n  background: linear-gradient(90deg, #2a5298, #1e3c72);\n}\n\n/* Testimonials Section */\n.testimonials-section {\n  margin: 80px auto;\n  max-width: 1200px;\n  padding: 0 20px;\n}\n\n.testimonials-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 30px;\n  margin-top: 40px;\n}\n\n.testimonial-card {\n  background: #222;\n  border-radius: 12px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.7);\n  padding: 30px;\n  width: 350px;\n  transition: all 0.4s ease;\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n.testimonial-card.animated {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.testimonial-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.9);\n}\n\n.testimonial-content {\n  font-style: italic;\n  line-height: 1.6;\n  color: #ccc;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.testimonial-content::before {\n  content: '\"';\n  font-size: 60px;\n  color: #fff;\n  opacity: 0.1;\n  position: absolute;\n  top: -20px;\n  left: -15px;\n}\n\n.testimonial-author {\n  display: flex;\n  align-items: center;\n}\n\n.author-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #0066cc;\n  margin-right: 15px;\n}\n\n.author-info h4 {\n  margin: 0;\n  /* color: #333; */\n  color: white;\n  font-weight: 600;\n}\n\n.author-info p {\n  margin: 5px 0 0;\n  color: #bcb4b4;\n  font-size: 0.9em;\n}\n\n/* Stats Section */\n.stats-section {\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  margin: 60px auto;\n  max-width: 1000px;\n  padding: 40px 20px;\n  background: linear-gradient(135deg, #000, #1a1a1a);\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);\n  color: white;\n  opacity: 0;\n  transform: translateY(30px);\n  transition: all 0.6s ease;\n}\n\n.stats-section.animated {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.stat-item {\n  text-align: center;\n  padding: 20px;\n}\n\n.stat-item h3 {\n  font-size: 3em;\n  margin: 0;\n  font-weight: 800;\n  background: linear-gradient(90deg, #ffffff, #cccccc);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.stat-item p {\n  margin-top: 10px;\n  font-size: 1.2em;\n  opacity: 0.9;\n}\n\n/* Animation for scroll elements */\n.animate-on-scroll {\n  opacity: 0;\n  transform: translateY(30px);\n  transition: opacity 0.8s ease, transform 0.8s ease;\n}\n\n.animate-on-scroll.animated {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Add delay to stagger animations */\n.blurb-section .blurb-item:nth-child(1) {\n  transition-delay: 0.1s;\n}\n\n.blurb-section .blurb-item:nth-child(2) {\n  transition-delay: 0.3s;\n}\n\n.blurb-section .blurb-item:nth-child(3) {\n  transition-delay: 0.5s;\n}\n\n.testimonials-container .testimonial-card:nth-child(1) {\n  transition-delay: 0.2s;\n}\n\n.testimonials-container .testimonial-card:nth-child(2) {\n  transition-delay: 0.4s;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .testimonial-card {\n    width: 100%;\n  }\n  \n  .stats-section {\n    flex-direction: column;\n    gap: 20px;\n  }\n}\n\n/* Force all text on HomePage to use Poppins ExtraLight font weight, except the header */\n.home-container *:not(.site-header *) {\n  font-weight: 300 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
